import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            textDecoration: 'none',
            color: theme.palette.primary.contrastText,
            marginRight: theme.spacing(1.5),
            '&:hover': {
                color: theme.palette.primary.main,
            },
            '@media print': {
                display: 'none',
            },
        },
        container: {
            backgroundColor: theme.palette.primary.main,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(0.5),
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            }
        },
    };
};
